import { keyframes } from "styled-components"

export const bounceArrow = keyframes`
  0% {opacity: 1; transform: translateX(0px) scale(1);}
  25%{opacity: 0; transform:translateX(8px) scale(0.9);}
  26%{opacity: 0; transform:translateX(-8px) scale(0.9);}
  55% {opacity: 1; transform: translateX(0px) scale(1);}
`
